import type { NewApptState } from '../types';

const selectClientId = (state: NewApptState) => state.newAppt.client.id || '';

export { selectClientId };
